// Stripe product/price mapping for PersonAI SaaS tiers
export const STRIPE_TIERS = {
  starter: {
    product_id: "prod_U7UXVF9Yq15Qgj",
    price_id: "price_1T9FY9DRGBnYut7cUBmjBPOZ",
    name: "Starter",
    price_brl: 49.9,
    max_students: 30,
    max_professors: 1,
    max_storage_mb: 200,
  },
  pro: {
    product_id: "prod_U7UXSVhg2A1acm",
    price_id: "price_1T9FYXDRGBnYut7cO3zYiPGX",
    name: "Pro",
    price_brl: 99.9,
    max_students: 100,
    max_professors: 3,
    max_storage_mb: 1024,
  },
  academy: {
    product_id: "prod_U7UYn3mJFRzVpG",
    price_id: "price_1T9FYuDRGBnYut7cm4cZu8m7",
    name: "Academy",
    price_brl: 199.9,
    max_students: 300,
    max_professors: 10,
    max_storage_mb: 5120,
  },
  enterprise: {
    product_id: "prod_U7UYnKT5BQEcfO",
    price_id: "price_1T9FZGDRGBnYut7cp673Nbll",
    name: "Enterprise",
    price_brl: 499.9,
    max_students: -1, // unlimited
    max_professors: -1, // unlimited
    max_storage_mb: 20480,
  },
  direct: {
    product_id: "prod_U8ZE4f3u1u4eZV",
    price_id: "price_1TAI5uDRGBnYut7cLD0WbTXT",
    name: "Direct",
    price_brl: 29.9,
    max_students: -1,
    max_professors: 0,
    max_storage_mb: 100,
  },
  chat_standalone: {
    product_id: "prod_ULIGtDXPby5X4r",
    price_id: "price_1TMbgADRGBnYut7cAiIIgwph",
    name: "PersonAI Chat",
    price_brl: 39.9,
    max_students: -1,
    max_professors: 0,
    max_storage_mb: 0,
  },
} as const;

export type StripeTierKey = keyof typeof STRIPE_TIERS;

export const getTierByProductId = (productId: string): StripeTierKey | null => {
  for (const [key, tier] of Object.entries(STRIPE_TIERS)) {
    if (tier.product_id === productId) return key as StripeTierKey;
  }
  return null;
};
